export default "__VITE_ASSET__BghiyBRS__"